/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Skill_DescInputs */

const en_mk_skill_desc = /** @type {(inputs: Mk_Skill_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick your divisions during onboarding and KerjaBareng wires up the channel and skill pack automatically — not a blank canvas you have to assemble yourself. Your team can delegate routine work immediately, and every finished task feeds back into sharpening that same skill pack.`)
};

const id_mk_skill_desc = /** @type {(inputs: Mk_Skill_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih divisi saat onboarding, KerjaBareng otomatis memasangkan channel dan skill pack-nya — bukan kanvas kosong yang harus kamu rakit sendiri. Timmu langsung bisa mendelegasikan tugas rutin, dan setiap tugas yang selesai jadi info baru yang mengasah skill pack itu sendiri.`)
};

/**
* | output |
* | --- |
* | "Pick your divisions during onboarding and KerjaBareng wires up the channel and skill pack automatically — not a blank canvas you have to assemble yourself. Y..." |
*
* @param {Mk_Skill_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_skill_desc = /** @type {((inputs?: Mk_Skill_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Skill_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_skill_desc(inputs)
	return en_mk_skill_desc(inputs)
});